import api from "@/services/api/api-driving-schools.js"
import { DrivingSchoolList } from "./models/driving-school-list"


export class DrivingSchoolService {

  async list(query) {
    try {
      let res = await api.list(query)
      return new DrivingSchoolList(res);
    } catch (err) {
      return Promise.reject(err)
    }
  }

  async post(data) {
    try {
      let res = await api.post({
        ...data,
        slug: data.slug.toLowerCase()
      })
      return res
    } catch (err) {
      return Promise.reject(err)
    }
  }

  async put(ID, data) {
    try {
      let res = await api.put(ID, {
        ...data,
        slug: data.slug.toLowerCase()
      })
      return res
    } catch (err) {
      return Promise.reject(err)
    }
  }

  async remove(ID) {
    try {
      let res = await api.remove(ID)
      return res
    } catch (err) {
      return Promise.reject(err)
    }
  }

}